import type { DocketRecord } from './docket-record'

/**
 * A court docket's saved record as a short markdown document for the content viewer: the
 * title, court, summary, every stored line the agent read, and both as-of dates.
 *
 * Every provider value is escaped, so it renders as literal text (a docket line that starts
 * "1." stays a line, not a numbered list) and the stored lines still match as highlights.
 */
export function buildAgentV2DocketRecordMarkdown(reference: DocketRecord): string {
  const { source, support } = reference
  const asOfDates = [`**Retrieved:** ${source.retrieved_at.slice(0, 10)}`]
  if (source.provider_last_updated) asOfDates.push(`**Docket last updated:** ${escapeMarkdownText(source.provider_last_updated)}`)

  const blocks = [
    `## ${escapeMarkdownText(source.title)}`,
    source.court ? `**Court:** ${escapeMarkdownText(source.court)}` : null,
    escapeMarkdownText(support.summary),
    support.selected_sentences.map((line) => `- ${escapeMarkdownText(line)}`).join('\n'),
    asOfDates.join(' • '),
    '*Live court record, not legal authority.*',
  ]
  return blocks.filter(Boolean).join('\n\n')
}

/** Backslash-escapes every ASCII punctuation mark and folds line breaks, so the text is one literal markdown line. */
function escapeMarkdownText(text: string): string {
  return text
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/[!-/:-@[-`{-~]/g, '\\$&')
}
